import { CommonModule } from '@angular/common'
import {
  Component,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core'
import { FormsModule } from '@angular/forms'
import { BadgeModule } from 'primeng/badge'
import { ButtonModule } from 'primeng/button'
import { TooltipModule } from 'primeng/tooltip'

@Component({
  selector: 'uploaded-file-row',
  standalone: true,
  template: `
    <ng-template
      #row
      let-file
      let-expandedRow="expandedRow"
      let-buttonTemplate="buttonTemplate"
      let-buttonTemplateContext="buttonTemplateContext"
      let-buttonHandler="buttonHandler"
      let-onFileClick="onFileClick"
    >
      <tr
        class="p-selectable-row"
        (click)="onFileClick(file)"
        [class.selected]="expandedRow === file.id"
        [pTooltip]="expandedRow ? 'Click to collapse' : 'Click to expand'"
        tooltipPosition="bottom"
      >
        <td>{{ file.name }}</td>
        <td>{{ file.date | date: 'dd/MM/yyyy - HH:mm' }}</td>
        <td>{{ file.source }}</td>
        <td>{{ file.created_by }}</td>
        <td>{{ file.repayment_count || '-' }}</td>
        <td>
          <p-badge
            [value]="getStatusLabel(file.status)"
            [severity]="getSeverity(file.status)"
            (click)="stage.emit({ originalEvent: $event, file })"
          />
        </td>
        <td *ngIf="buttonTemplate">
          <ng-container
            *ngTemplateOutlet="buttonTemplate; context: buttonTemplateContext"
          ></ng-container>
        </td>
      </tr>
    </ng-template>
  `,
  imports: [
    CommonModule,
    BadgeModule,
    ButtonModule,
    TooltipModule,
    FormsModule,
  ],
})
export class UploadedFileRowComponent {
  @ViewChild('row', { static: true }) row!: TemplateRef<any>

  @Input() buttonTemplate!: TemplateRef<any>
  @Input() buttonTemplateContext: any = {}

  @Output() clickRow = new EventEmitter<any>()
  @Output() stage = new EventEmitter<any>()

  getSeverity(status: string) {
    const normalized = status?.toUpperCase() || ''
    if (normalized.startsWith('ERROR')) return 'danger'
    switch (normalized) {
      case 'PROCESSING':
        return 'info'
      case 'UNSAVED':
        return 'warn'
      case 'COMMITTING':
        return 'info'
      case 'DELETING':
        return 'info'
      case 'DELETE_FAILED':
        return 'danger'
      default:
        return 'success'
    }
  }

  getStatusLabel(status: string): string {
    const normalized = status?.toUpperCase() || ''
    if (normalized.startsWith('ERROR')) return status
    switch (normalized) {
      case 'PROCESSING':
        return 'Importing'
      case 'UNSAVED':
        return 'Unsaved'
      case 'COMMITTING':
        return 'In progress'
      case 'DELETING':
        return 'Deleting'
      case 'DELETE_FAILED':
        return 'Delete failed'
      default:
        return 'Saved'
    }
  }
}
